/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Daily random room rotation for Nurse Practitioners working in-clinic at a clinic. Each day, 30 minutes before the clinic opens, each such NP is given a distinct random room from rooms (Physician.default_room) and texted it.
 * @export
 * @interface ClinicRoomRotation
 */
export interface ClinicRoomRotation {
    /**
     * 
     * @type {boolean}
     * @memberof ClinicRoomRotation
     */
    enabled?: boolean;
    /**
     * The rotation pool. Every entry must be one of the clinic's rooms, with no duplicates.
     * @type {Array<string>}
     * @memberof ClinicRoomRotation
     */
    rooms?: Array<string>;
}

/**
 * Check if a given object implements the ClinicRoomRotation interface.
 */
export function instanceOfClinicRoomRotation(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClinicRoomRotationFromJSON(json: any): ClinicRoomRotation {
    return ClinicRoomRotationFromJSONTyped(json, false);
}

export function ClinicRoomRotationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClinicRoomRotation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'rooms': !exists(json, 'rooms') ? undefined : json['rooms'],
    };
}

export function ClinicRoomRotationToJSON(value?: ClinicRoomRotation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'rooms': value.rooms,
    };
}

